import {
  Palette,
  Users
} from 'lucide-react';

export interface Job {
  id: number;
  title: string;
  department: string;
  location: string;
  type: string;
  salary: string;
  experience: string;
  description: string;
  skills: string[];
  icon: any;
  requirements: string[];
  responsibilities: string[];
  benefits: string[];
  managementSkills?: string[];
  judgement?: string[];
  skillsAndQualifications?: string[];
  preferredExperience?: string[];
}

export const jobsData: Record<string, Job> = {
  '1': {
    id: 1,
    title: "Entry Level Frontend and Graphic Designer",
    department: "Design",
    location: "Remote (Nepal Based)",
    type: "Permanent – Full-time",
    salary: "Competitive",
    experience: "1+ years",
    description:
      "We are seeking a passionate and creative Entry Level Frontend and Graphic Designer to join our growing team. In this role, you will bridge the gap between visual design and digital implementation — designing stunning websites, digital marketing materials, logos, pamphlets, social media graphics, and brand collateral, while also translating those designs accurately into frontend interfaces. You should have a strong eye for aesthetics, a solid grasp of design principles, and the ability to bring a brand's vision to life across both screen and print.",
    skills: ["Adobe Photoshop", "Adobe Illustrator", "InDesign", "Figma", "Canva", "HTML5", "CSS3", "JavaScript", "WordPress"],
    icon: Palette,
    requirements: [],
    responsibilities: [
      "Design and develop responsive, visually appealing website layouts and UI/UX interfaces for client projects.",
      "Translate design mockups and prototypes into clean, functional frontend code using HTML, CSS, and basic JavaScript.",
      "Create digital marketing assets including social media graphics, banner ads, email templates, and promotional visuals.",
      "Design print-ready materials such as pamphlets, brochures, flyers, posters, and banners.",
      "Develop and refine brand identities including logo design, typography selection, and color palette development.",
      "Collaborate closely with backend developers to ensure accurate implementation of frontend designs.",
      "Maintain consistency in brand guidelines across all digital and print touchpoints.",
      "Produce and optimize image assets for web performance and digital marketing campaigns.",
      "Stay current with design trends, frontend technologies, and best practices in UI/UX and graphic design.",
      "Communicate design concepts clearly to clients and internal stakeholders, and incorporate feedback effectively."
    ],
    skillsAndQualifications: [
      "Proficiency in industry-standard design tools such as Adobe Creative Suite (Photoshop, Illustrator, InDesign), Figma, or Canva.",
      "Working knowledge of frontend technologies including HTML5, CSS3, and basic JavaScript.",
      "Strong understanding of UI/UX design principles, typography, color theory, and layout composition.",
      "Experience designing for digital platforms including websites, social media, and email marketing.",
      "Ability to create print-ready designs for pamphlets, brochures, banners, and other marketing collateral.",
      "Solid logo design and brand identity development skills.",
      "Familiarity with responsive and mobile-first design concepts.",
      "Understanding of image optimization for web performance and digital advertising.",
      "Familiarity with WordPress or similar CMS platforms from a design and basic customization perspective is a plus.",
      "Excellent attention to detail with a strong sense of visual aesthetics.",
      "A self-motivated individual who can work independently in a remote environment."
    ],
    preferredExperience: [
      "Bachelor's degree or diploma in Graphic Design, Visual Communication, Fine Arts, Multimedia, Web Design, or a related field, and/or equivalent professional experience.",
      "Minimum 1 year of hands-on experience in graphic design, frontend design, or digital marketing design.",
      "A strong portfolio demonstrating a range of work across digital design, graphic design, and frontend interfaces.",
      "Experience working with content management systems (e.g., WordPress, Shopify) from a design and basic customization perspective.",
      "Familiarity with social media platforms and their respective design specifications.",
      "Prior experience working with international clients or in a remote work environment is a plus."
    ],
    managementSkills: [
      "Strong time management skills with the ability to juggle multiple design projects and meet deadlines.",
      "Ability to coordinate effectively with developers, marketers, and clients to deliver cohesive visual and digital outcomes.",
      "Clear and professional communication, both written and verbal, within and outside the organization.",
      "A collaborative mindset with a willingness to give and receive constructive creative feedback."
    ],
    judgement: [
      "Ability to make sound design and frontend decisions based on client requirements, brand guidelines, and target audience needs.",
      "Problem-solving approach when navigating creative and technical challenges, with openness to guidance and mentorship.",
      "Commitment to continuous improvement of both design and frontend development skills."
    ],
    benefits: [
      "Competitive salary with performance-based bonuses.",
      "Professional development opportunities and access to design resources and tools.",
      "Opportunity to work on exciting international projects with a diverse, creative team.",
      "Flexible remote work environment with a strong focus on work-life balance.",
      "Be part of a collaborative, innovative, and supportive workplace culture where your creativity is truly valued."
    ]
  },
  '2': {
    id: 2,
    title: "IT Support Specialist",
    department: "Operations",
    location: "Remote",
    type: "Full-time",
    salary: "$60k/yr - $80k/yr",
    experience: "2+ years",
    description:
      "We are looking for an IT Support Specialist to help our team solve technical issues and maintain our systems. You will assist employees with hardware, software, and network problems.",
    skills: ["Windows", "macOS", "Networking", "Technical Support"],
    icon: Users,
    requirements: [
      "2+ years of IT support experience",
      "Good knowledge of Windows and macOS",
      "Basic networking knowledge",
      "Strong troubleshooting skills",
      "Good communication and customer support skills"
    ],
    responsibilities: [
      "Provide technical support to team members",
      "Troubleshoot hardware and software issues",
      "Set up computers and work tools",
      "Maintain internal IT systems",
      "Document common solutions and processes"
    ],
    benefits: [
      "Remote work",
      "Flexible working hours",
      "Supportive work environment",
      "Learning and career growth opportunities"
    ]
  }
};